export default {
      id: "accessable-logo-usage",
      viewBox: "0 0 189.5 38.1",
      url: "/" + "sprite.svg#accessable-logo",
      toString: function () {
        return this.url;
      }
    }